import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { CnesEstabelecimentoResumo } from '../models/cnes-estabelecimento-resumo.model';
import { CnesResponse } from '../models/cnes-response.model';
import { CnesAtualizacaoResponse } from '../models/cnes-atualizacao-response.model';
import { unwrapApiEnvelopeData } from '../../../core/utils/api-envelope.util';

@Injectable({ providedIn: 'root' })
export class CnesService {
  private http = inject(HttpClient);
  private readonly url = `${environment.fullApiUrl}/v1/cnes`;

  buscar(cnes: string): Observable<CnesResponse> {
    return this.http.get<unknown>(`${this.url}/${encodeURIComponent(cnes)}`).pipe(
      map((body) => unwrapApiEnvelopeData<CnesResponse>(body, {} as CnesResponse))
    );
  }

  /** Estabelecimentos vinculados ao CPF do token (via CNES API). */
  listarMeusEstabelecimentos(): Observable<CnesEstabelecimentoResumo[]> {
    return this.http.get<unknown>(`${this.url}/me/estabelecimentos`).pipe(
      map((body) => unwrapApiEnvelopeData<CnesEstabelecimentoResumo[]>(body, []))
    );
  }

  /** Reconsulta a API de habilitação CNES e atualiza tb_estabelecimento se houver divergência. */
  atualizar(cnes: string): Observable<CnesAtualizacaoResponse> {
    return this.http
      .put<unknown>(`${this.url}/${encodeURIComponent(cnes)}/atualizar`, {})
      .pipe(map((body) => unwrapApiEnvelopeData<CnesAtualizacaoResponse>(body, {} as CnesAtualizacaoResponse)));
  }
}
